module.exports = __webpack_public_path__ + "static/day08-83e3c910099b70f5ca2e0fbf46759986.png";